import React, { useEffect, useState } from 'react';
import { Link, useParams } from "react-router-dom";
import AuthApi from "../../api/auth";
import toast from 'react-hot-toast';
import * as Yup from "yup";
import { ErrorMessage, Field, Form, Formik } from "formik";



let VerifyAccount = () => {
   let params = useParams();
   const [loading, setLoading] = useState(false);
   const [message, setMessage] = useState("");
   const [error, setError] = useState(false);

   useEffect(() => {
      verificationAccount()
   }, [])

   const verificationAccount = async () => {
      try {
         setLoading(true)
         let res = await AuthApi.verifyAccount({ email: params?.email, otp: params?.otp })
         if (res.status == 200) {
            setMessage(res.data?.msg)
         }
         setLoading(false)
      } catch (error) {
         console.log(error.message);
         setMessage("Failed to verify link.");
         setLoading(false)
         setError(true)
      }
   }
   return (
      <div className='bg-global'>
         <div className="container">
            <div className="row">
               <div className="col-12">
                  <div className="authContainerWrapper">
                     <div>
                        <h2 className="font-xxl pb-3">Account Verification</h2>
                        {loading ? "Verifying..." : (
                           <div className={`${error ? "alert-danger" : "alert-success"} alert`}>
                              {message}
                           </div>
                        )}
                        <div className="form-group form-check py-3">
                           <Link exact="true" to="/login" className="d-flex justify-content-end align-items-center font-bold">Login to Account</Link>
                        </div>
                     </div>
                  </div>
               </div>
            </div>
         </div>
      </div>
   )
}

export default VerifyAccount